import { BehaviorSubject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'

class DetailBloc {
    detailRepository = new DetailRepository()
    
    detailChannel = new BehaviorSubject({
        status: apiResponse.INITIAL,
        data: []
    })

    async fetchDetail(data) {
        this.detailChannel.next({
            status: apiResponse.LOADING,
            data: []
        })

        try {
            const response = await this.detailRepository.fetchDetail(data)
            this.detailChannel.next({
                status: apiResponse.COMPLETED,
                data: response
            })
        } catch (error) {
            this.detailChannel.next({
                status: apiResponse.ERROR,
                data: error
            })
        }
    }
}

export default DetailBloc
